var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"thumbnail",rawName:"v-thumbnail",value:(_vm.src),expression:"src"}],on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }